import { View, StyleSheet } from 'react-native';
import { Reminder, Text, theme } from '@socrait/react';

import { Period, ActionItem } from '~/services/types';
import { formatYMDToLongDateString } from '~/utils/date';

type PeriodRemindersItemProps = {
  period: Period;
  date: Date;
  reminders: ActionItem[];
  loadingIDs: string[];
  onUpdateActionItemStatus: (reminder: ActionItem) => void;
};

export const PeriodRemindersItem = ({
  period,
  date,
  reminders,
  loadingIDs,
  onUpdateActionItemStatus,
}: PeriodRemindersItemProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.periodContainer}>
        <View style={styles.periodTitleContainer}>
          <Text style={styles.periodShortName}>{period.shortName}</Text>
          <View style={styles.periodTitle}>
            <Text style={styles.periodTitleText}>{period.name}</Text>
            <Text style={styles.periodDate}>{formatYMDToLongDateString(date)}</Text>
          </View>
        </View>
      </View>
      <View style={styles.remindersContainer}>
        {reminders.map((reminder, index) => (
          <Reminder
            key={index}
            details={reminder.title}
            status={reminder.status}
            containerStyle={styles.reminder}
            loading={loadingIDs.includes(reminder.id)}
            onPress={() => onUpdateActionItemStatus(reminder)}
          />
        ))}
      </View>
    </View>
  );
};

const textStyle = {
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.bold,
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing.medium,
  },
  periodContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.medium,
    maxWidth: 350,
  },
  periodTitleContainer: {
    backgroundColor: theme.colors.lightGray,
    borderTopLeftRadius: theme.borderRadius.large * 3,
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing.medium,
    padding: theme.spacing.medium,
  },
  periodShortName: {
    ...textStyle,
    alignItems: 'center',
    backgroundColor: theme.colors.gray,
    borderRadius: 50,
    display: 'flex',
    flexDirection: 'column',
    height: 50,
    justifyContent: 'center',
    width: 50,
    flexShrink: 0,
  },
  periodTitle: {
    flexDirection: 'column',
    gap: theme.spacing.medium,
  },
  periodTitleText: {
    ...textStyle,
  },
  periodDate: {
    ...textStyle,
    color: theme.colors.darkGray,
  },
  remindersContainer: {
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing.medium,
  },
  reminder: {
    maxWidth: 'initial',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.gray,
  },
});
